import { get } from 'lodash-es';
import {
  InternalRpcError,
  TransactionExecutionError,
  TransactionNotFoundError,
  UnknownRpcError,
} from 'viem';

// for L2 transactions, transaction cost has an L1 part of the fee and L2 part of the fee
// wallets only estimate the L2 part of the fee, but the rpc node will throw if the user doesn't have enough for the l1 fee
function isInsufficientFundsRpcError(error: unknown) {
  if (error instanceof TransactionExecutionError) {
    const { details } = error;
    return details?.includes('insufficient funds');
  }
  return false;
}

export function isInsufficientFundsError(error: unknown) {
  const detailsErrorMessage: unknown = get(error, 'cause.details');
  const rootErrorMessage: unknown = get(error, 'message');

  return (
    isInsufficientFundsRpcError(error) ||
    (typeof detailsErrorMessage === 'string' &&
      detailsErrorMessage.toLowerCase().includes('insufficient funds')) ||
    (typeof rootErrorMessage === 'string' &&
      rootErrorMessage.toLowerCase().includes('insufficient funds'))
  );
}

export function isUnknownRpcError(error: unknown) {
  return error instanceof UnknownRpcError;
}

export function isInternalRpcError(error: unknown) {
  return error instanceof InternalRpcError;
}

export function isTransactionNotFoundError(error: unknown) {
  return error instanceof TransactionNotFoundError;
}
